var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-end mb-4" },
    [
      _c(
        "b-col",
        { attrs: { cols: "3" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "0.5rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "1" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "0.5rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "2" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "0.5rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "3" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "0.5rem",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "2" } },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "0.5rem",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }